'use client'

type Props = {
  containerRef: React.RefObject<HTMLDivElement | null>
  mapsLink: string
  label: string
  ctaLabel?: string
  /** Hide the floating directions CTA (e.g. Home split layout). */
  showCta?: boolean
  className?: string
}

export default function MapCanvas({
  containerRef,
  mapsLink,
  label,
  ctaLabel = 'View Location & Nearby Places',
  showCta = true,
  className = 'relative w-full h-[320px] shrink-0 md:h-full md:min-h-0',
}: Props) {
  const hasMapsKey = Boolean(
    process.env.NEXT_PUBLIC_GOOGLE_MAPS_EMBED_KEY?.trim(),
  )

  return (
    <div data-fig="1:1262" className={className}>
      <div
        ref={containerRef}
        className="absolute inset-0 h-full w-full"
        aria-label={label}
        role="region"
      />

      {!hasMapsKey && (
        <div
          className="absolute inset-0 z-[1] flex items-center justify-center bg-[#E8E4DE] px-6 text-center"
          role="status"
        >
          <p className="font-body text-sm font-medium leading-5 text-[#575757]">
            Map unavailable — set{' '}
            <code className="font-mono text-xs">
              NEXT_PUBLIC_GOOGLE_MAPS_EMBED_KEY
            </code>{' '}
            in your environment.
          </p>
        </div>
      )}

      {showCta && (
        <div className="hidden md:absolute bottom-4 left-1/2 z-10 -translate-x-1/2">
          <a
            href={mapsLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-pill bg-brand-dark px-5 py-2.5 font-body text-[13px] text-button text-text-on-dark shadow-card transition-opacity hover:opacity-90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-primary md:px-6 md:py-3 md:text-base"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
            {ctaLabel}
          </a>
        </div>
      )}
    </div>
  )
}
